import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import Product from "emun.shopping/product.model";
import partsEntryGridTemplate from "emun.order/parts/parts-entry-grid.htm";
import labels from "emun.order/_labels";
import ProductListPicker from "emun.products/lists/product-list-picker";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import actionList from "webmodals/action-list";

const $localStorage = resolve("$localStorage");

export default class OrderManualSplitController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = labels;
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.$cart.items.map((l) => (l.selected = false));
  }

  addToList() {
    const $ctrl = this;
    ProductListPicker.open({
      productIds: $ctrl.$cart.items
        .filter((l) => l.selected)
        .map((l) => l.productId),
    }).then(function () {
      $ctrl.$cart.items.forEach(function (item) {
        if (item.selected)
          $ctrl.$cart.bus.send("RemoveCartItem", item).then(function () {
            $ctrl.$cart.load();
            $ctrl.productIds = [];
          });
      });
    });
  }

  newOrder() {
    const $ctrl = this;
    return modals
      .confirm("Add selected item(s) to a new order?", "New Order")
      .result.then(function () {
        $ctrl.$cart.bus
          .send("DuplicateOrder", {
            OrderNumber: $ctrl.$cart.id,
            Type: "Cart",
            LinePositions: $ctrl.$cart.items
              .filter((l) => l.selected)
              .map((l) => l.position),
            RemoveLines: true,
          })
          .then(function (response) {
            $ctrl.$cart.addOrderToSession({
              id: response.data.id,
              name: response.data.cartName || response.data.id,
              companyName: response.data.purchaser.companyName,
              customerID: response.data.purchaser.id,
              status: response.data.status,
              vendor: response.data.vendorId,
            });
            $ctrl.$cart.load();
            $ctrl.productIds = [];
            return modals
              .confirm(
                "Order#: " +
                  response.data.id +
                  "\r\nTotal: $" +
                  response.data.grandTotal.toFixed(2) +
                  "\r\n\r\nGo to new order?",
                "New Order Created"
              )
              .result.then(function () {
                $ctrl.$dismiss();
                $ctrl.$state.go("orders.detail", { orderId: response.data.id });
              });
          });
      });
  }

  newQuote() {
    const $ctrl = this;
    return modals
      .confirm("Add selected item(s) to a new quote?", "New Quote")
      .result.then(function () {
        $ctrl.$cart.bus
          .send("DuplicateOrder", {
            OrderNumber: $ctrl.$cart.id,
            Type: "Quote",
            LinePositions: $ctrl.$cart.items
              .filter((l) => l.selected)
              .map((l) => l.position),
            RemoveLines: true,
          })
          .then(({ data }) => {
            $ctrl.$cart.addOrderToSession({
              id: data.id,
              name: data.cartName || ord.id,
              companyName: data.purchaser.companyName,
              customerID: data.purchaser.id,
              status: data.status,
              vendor: data.vendorId,
            });
            $ctrl.$cart.load();
            $ctrl.productIds = [];
            return modals
              .confirm(
                "Quote#: " +
                  data.id +
                  "\r\nTotal: $" +
                  data.grandTotal.toFixed(2) +
                  "\r\n\r\nGo to new quote?",
                "New Quote Created"
              )
              .result.then(function () {
                $ctrl.$dismiss();
                $ctrl.$state.go("orders.detail", { orderId: data.id });
              });
          });
      });
  }

  save() {
    const $ctrl = this;
  }
  setProductIds() {
    const $ctrl = this;
    $ctrl.productIds = $ctrl.$cart.items
      .filter((l) => l.selected)
      .map((l) => l.productId)
      .join(",");
  }
}
